import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User } from "lucide-react";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    // KIỂM TRA MẬT KHẨU (Bạn có thể sửa lại theo ý muốn)
    if (username === "admin" && password === "123456") {
      localStorage.setItem("authToken", "secret-token-123"); // Lưu token
      navigate("/admin/dashboard"); // Chuyển hướng
    } else {
      setError("Sai tên đăng nhập hoặc mật khẩu!");
    }
  };

  return (
    <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "#f3f4f6" }}>
      <div style={{ background: "white", padding: "40px", borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", width: "100%", maxWidth: "400px" }}>
        <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#333" }}>Quản Trị Viên</h2>
        
        {error && <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "10px", borderRadius: "6px", marginBottom: "15px", fontSize: "0.9rem" }}>{error}</div>}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>Tài khoản</label>
            <div style={{ position: "relative" }}>
              <User size={18} style={{ position: "absolute", top: "10px", left: "10px", color: "#999" }} />
              <input 
                type="text" 
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={{ width: "100%", padding: "10px 10px 10px 35px", border: "1px solid #ddd", borderRadius: "6px" }}
                placeholder="admin"
              />
            </div>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "500" }}>Mật khẩu</label>
            <div style={{ position: "relative" }}>
              <Lock size={18} style={{ position: "absolute", top: "10px", left: "10px", color: "#999" }} />
              <input 
                type="password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: "100%", padding: "10px 10px 10px 35px", border: "1px solid #ddd", borderRadius: "6px" }}
                placeholder="123456"
              />
            </div>
          </div>

          <button type="submit" style={{ width: "100%", padding: "12px", background: "#2563eb", color: "white", border: "none", borderRadius: "6px", fontWeight: "bold", cursor: "pointer" }}>
            Đăng Nhập
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;